import React from 'react';
import Hdr from './shared/Hdr';
import Progress from './Progress';
import { useState, useEffect, useRef } from 'react';
import swal from 'sweetalert';
import { apiPath } from "../src/services/apiConfig";

function DiagService() {
  const user = localStorage.getItem('user-info');
  const token = localStorage.getItem('token');
  const usrRole = localStorage.getItem('user-role');
  const [displayDiagService, setDisplayDiagService] = useState('none');
  const [displayUpdDiagService, setDisplayUpdDiagService] = useState('none');
  const [data, setData] = useState([]);
  const [dataStat, setDataStat] = useState();
  const [verfied, setVerfied] = useState(true);
  const [id, setID] = useState('');
  //  const [Err, SetErr] = useState([]);
  const handleSubmit = () => {
    verifyDiagService()
    if (verfied) {
      formRef.current.reset();
    }
  }
  const formRef = useRef();
  //  const [doctorSpecilation, setDoctorSpecialisation] = useState();
  const [serial, setSerial] = useState('');
  //  const [specialityDataStat, setSpecialityDataStat] = useState('')
  const [shortDesc, setShortDesc] = useState('');
  // const [longDesc, setLongDesc] = useState('');
  //  const [specialityData, setSpecialityData] = useState([])
  //  const [updSpecialitiy, setUpdSpeciality] = useState()
  //  const [defaultSpeciality, setDefaultSpeciality] = useState('1')
  const [isloading, setIsLoading] = useState(false)
  //  const [iconpath, setIconPath] = useState()
  const [updSerial, setUpdSerial] = useState()
  const [updShortDesc, setUpdShortDesc] = useState()
  //  const [updLongDesc, setUpdLongDesc] = useState()
  const [filteredID, setFilteredId] = useState()
  const [diogDatastat, setDiogDataStat] = useState()
  const [diogData, setDiogData] = useState([])


  const [introConclusionStat, setIntroConclusionStat] = useState()
  const [introConclusionData, setIntroConclusionData] = useState()
  const [updIntro, setUpdIntro] = useState('')
  const [updConclusion, setUpdConclusion] = useState('')
  const [dataExist, setDateExist] = useState(false)
  const [updId, setUpdId] = useState(0)

  let txt = "";

  useEffect(() => {
    getDiagnosis()
  }, [])

  function openDiagService() {
    setDisplayDiagService('block')
  }

  function closeDiagService() {
    formRef.current.reset();
    setDisplayDiagService('none')
  }

  function openUpdDiagService() {
    setDisplayUpdDiagService('block')
  }

  function closeUpdDiagService() {
    setDisplayUpdDiagService('none')
  }

  async function updateDiagService(id) {
    //    alert(id+','+filteredID+","+updSerial+", "+updShortDesc)

    let result = await fetch(apiPath + "updateDiagServices", {
      method: 'PUT',
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify({
        "id": id,
        "diagnostic_id": filteredID,
        "srl": updSerial,
        "short_desc": updShortDesc
      })
    });
    result = await result.json();

    showSwal(result.success, result.message)
    getDiagService(filteredID)
  }

  async function deleteDiagService(id, sp_id) {

    let result = await fetch(apiPath + "deleteDiagService/" + id, {
      method: 'DELETE',
      headers: {
        "Authorization": `Bearer ${token}`
      },
    });
    result = await result.json();

    showSwal(result.success, result.message)

    getDiagService(filteredID)
  }

  async function updateOperation(id) {
    //  alert('for update..'+id)
    let result = await fetch(apiPath + "getOneServicesByDiagnostic/" + id,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });

    result = await result.json();
    console.log(result.data)

    setUpdSerial(result.data[0].srl);
    setUpdShortDesc(result.data[0].short_desc)
    setID(result.data[0].id)

    openUpdDiagService();
  }

  function deleteOperation(id, sp_id) {

    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
      .then((willDelete) => {
        if (willDelete) {
          deleteDiagService(id, sp_id);
        }
        else {
          swal("Your record is safe!");
        }
      });
  }


  //* LIST OF ALL DiagService (for initial screen)*/ 

  async function getDiagService(id) {

    let result = await fetch(apiPath + "getServicesByDiagnostic/" + id,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      })

    result = await result.json();
    setDataStat(result.success);
    setData(result.data);
    if (result.success === true) {
      setData(result.data);
    } else { setData([]) }
  }

  function verifyDiagService() {

    setVerfied(true)
    addDiagService()
  }

  //*ADD A NEW DiagService*/ 
  async function addDiagService() {

    if (verfied) {
      setIsLoading(true)
      let result = await fetch(apiPath + "storeDiagServices", {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({
          "diagnostic_id": filteredID,
          "srl": serial,
          //         "icon": "/images/icons-speciality/" + filteredID + "_icon_" + serial + ".png",
          "short_desc": shortDesc,
          //        "long_desc": longDesc
        })
      });
      result = await result.json();
      //  console.warn(result)

      //      if (result.success) { }
      //      else {
      //        SetErr(result.data);
      //      }

      showSwal(result.success, result.message)

      getDiagService(filteredID)

      if (isloading) {
      } else {
        setIsLoading(false)
      }
    }
  }

  function showSwal(stat, txt) {
    if (stat === true) {
      swal({
        title: "Success!",
        text: txt,
        icon: "success",
        button: "OK!",
      });
    } else {
      swal({
        title: "Fail!",
        text: txt,
        icon: "error",
        button: "OK!",
      });
    }
  }

  //* LIST OF ALL DIAGNOSIS (for combo)*/ 

  async function getDiagnosis() {
    let result = await fetch(apiPath + "diagnostics",
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      })
    result = await result.json();

    setDiogDataStat(result.success);
    setDiogData(result.data);

    console.log(result.data)

    if (result.success === true) {
      setDiogData(result.data);
    } else { setDiogData([]) }
  }

  function FilterData(id) {
    setFilteredId(id)
  }

  function FindDiagService() {
    getDiagServiceIntroConclusion(filteredID)
    getDiagService(filteredID)
  }

  async function getDiagServiceIntroConclusion(id) {
    //  alert(id)
    let result2 = await fetch(apiPath + "getDiagServiceIntro/" + id,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      })

    result2 = await result2.json();
    setIntroConclusionStat(result2.success);

    if (result2.success === true) {

      if (result2.message === 'No record found') {
        setDateExist(false)
        setIntroConclusionData([])
        setUpdIntro('')
        setUpdConclusion('')
        setUpdId(0)
      }
      else {
        setIntroConclusionData(result2.data);
        setUpdIntro(result2.data[0].intro)
        setUpdId(result2.data[0].id)
        setUpdConclusion(result2.data[0].conclusion)
        setDateExist(true)
      }
    } else {
    }
  }

  async function AddIntroConclusion() {
    //  alert(filteredID+', '+updIntro+', '+updConclusion)
    let result = await fetch(apiPath + "storeDiagServiceIntroConclusion", {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify({
        "diagnostic_id": filteredID,
        "intro": updIntro,
        "conclusion": updConclusion,
      })
    });
    result = await result.json();

    if (result.success) {
      setUpdIntro('')
      setUpdConclusion('')
    }
    else {
      //       SetErr(result.data);
    }

    showSwal(result.success, result.message)
  }

  async function UpdateIntroConclusion() {
    // alert(updId+',...'+filteredID+', '+updIntro+', '+updConclusion)
    let result = await fetch(apiPath + "updateDiagServiceIntroConclusion", {
      method: 'PUT',
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify({
        "id": updId,
        "diagnostic_id": filteredID,
        "intro": updIntro,
        "conclusion": updConclusion,
      })
    });
    result = await result.json();
    //  console.warn(result)

    if (result.success) {
      setUpdIntro('')
      setUpdConclusion('')
    }
    else {
      ///       SetErr(result.data);
    }

    showSwal(result.success, result.message)
    setDataStat(false)
  }


  return (

    <div style={{ 'height': '90vh' }}>
      <Hdr />
      <div className="row p16">
        <div className="c12-l-8">
          <h3 className="" >ADS Hospital - User : {user} </h3>
        </div>
        <div className="c12-l-4 pr32 ">
          <p className="medium right">User : ({usrRole})</p>
        </div>
      </div>


      <div className="row p16" style={{ 'height': '90%' }}>
        <div className=" c12-l-12 cont__content p4" style={{ 'height': '100%' }}>
          <div className="row p16">
            <div className="c12-l-3">
              <h4 className="wide">Diagnostic Service</h4>
            </div>
            <div className="c12-l-5"></div>
            <div className="c12-l-2">
              <select className="custom-select" onChange={(e) => FilterData(e.target.value)}>
                {
                  (diogDatastat === true ?
                    (
                      diogData.map((item2, index) =>
                        <option value={item2.id}>{item2.name}</option>
                      ))
                    : <tr><td>No data</td></tr>)
                }
              </select>
            </div>

            <div className="c12-l-1">
              <button onClick={FindDiagService} type="button" name="button"
                className="btn solid round">Find DiagService</button>
            </div>
            <div className="c12-l-1">
              {dataExist === true ? (
                <div>
                  <button onClick={openDiagService} type="button" name="button"
                    className="btn solid round">Add DiagService</button>
                </div>
              ) : (
                <div></div>
              )}
            </div>
          </div>
          <div className="row mt16" >
            <div className="c12-l-1"></div>
            <div className="c12-l-1">Introduction</div>
            <div className="c12-l-9">
              <textarea className="box small"
                placeholder="Introduction" onChange={(e) => setUpdIntro(e.target.value)}
                value={updIntro} />
            </div>
            <div className="c12-l-1"></div>
            <div className="c12-l-1"></div>
            <div className="c12-l-1">Conclusion</div>
            <div className="c12-l-9">
              <textarea className="box small" rows="2"
                placeholder="Conclusion" onChange={(e) => setUpdConclusion(e.target.value)}
                value={updConclusion} />
            </div>
            <div className="c12-l-1">
              {dataExist === true ? (
                <div>
                  <button onClick={UpdateIntroConclusion} type="button" name="button"
                    className="btn solid round">Update</button>
                </div>
              ) : (
                <div>
                  <input type="hidden" value={updId} />

                  <button onClick={AddIntroConclusion} type="button" name="button"
                    className="btn solid round">Add Intro-conclution</button>
                </div>
              )}

            </div>
          </div>

          <div className="row mt16" >
            <table style={{ 'height': '100%', 'width': '100%', 'overflowY': 'scroll', 'overflowX': 'scroll', 'display': 'block' }}>
              <thead>
                <tr>
                  <th className="th-border center" width="15%">Id</th>
                  <th className="th-border center" width="15%">Srl</th>
                  <th className="th-border center" width="27%">Icon</th>
                  <th className="th-border left" width="45%">Short Desc</th>
                  <th className="th-border left" width="15%">Edit</th>
                  <th className="th-border left" width="15%">Delete</th>
                </tr>
              </thead>
              <tbody >
                {
                  (dataStat === true ?
                    (
                      data.map((item, index) =>
                        <tr className="tr-border" key={index}>
                          <td className="center">{item.id}</td>
                          <td className="center">{item.srl}</td>
                          <td className="center"><img src={`https://adshospital.site${item.icon}`} width={25} height={25} alt=''></img></td>
                          <td className="left">{item.short_desc}</td>
                          <td onClick={() => { updateOperation(item.id) }} className="center"><img src={require('./asset/images/adm_edit.png')} alt="" /></td>
                          <td onClick={() => { deleteOperation(item.id, { filteredID }) }} className="center"><img src={require('./asset/images/adm_del.png')} alt="" /></td>
                        </tr>
                      ))
                    : <tr><td>No data</td></tr>)
                }
              </tbody>
            </table>
          </div>

          {/* SCREEN FROM ADDING NEW DiagService */}

          <div id="newdept" style={{ 'display': displayDiagService }} className="cont__new-dept">
            <form className="" action="" method="" ref={formRef}>
              <div className="row">
                <div className="c12-l-11"></div>
                <div className="c12-l-1 center">
                  <p onClick={closeDiagService}><img src={require('./asset/images/adm_close.png')} alt="" width="24px" height="24px" /></p>
                </div>
              </div>
              <div className="row mt32">
                <div className="c12-l-12">
                  <h2>Add a DiagService</h2>
                  <br></br>

                  <input type="hidden" value={filteredID} />

                  <input type="text" className="box small" autoComplete="off"
                    placeholder="Serial" onChange={(e) => setSerial(e.target.value)} />

                  <textarea className="box small" autoComplete="off" rows='10'
                    placeholder="Short Description" onChange={(e) => setShortDesc(e.target.value)} />

                  <br></br>
                  <button onClick={handleSubmit} type="button"
                    className="btn solid round">Add DiagService</button>

                  {
                    (isloading === true ?

                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginTop: '5px'
                      }}><Progress /></div>
                      :
                      <div></div>
                    )
                  }
                </div>
              </div>
            </form>
          </div>

          {/* SCREEN FROM UPDTAE EXISTING DiagService */}

          <div id="newdept" style={{ 'display': displayUpdDiagService }} className="cont__new-dept">
            <form className="" action="" method="">
              <div className="row">
                <div className="c12-l-11"></div>
                <div className="c12-l-1 center">
                  <p onClick={closeUpdDiagService}><img src={require('./asset/images/adm_close.png')} alt="" width="24px" height="24px" /></p>
                </div>
              </div>

              <div className="row mt32">
                <div className="c12-l-12">
                  <h2>Edit DiagService</h2><br /><br />

                  <input type="hidden" value={id} />
                  <p style={{ 'fontSize': '0.65rem' }}>Serial Number</p>
                  <input type="text" className="box small"
                    placeholder="Serial" onChange={(e) => setUpdSerial(e.target.value)}
                    value={updSerial} />
                  <br />

                  <p style={{ 'fontSize': '0.65rem' }}>Short Description</p>
                  <input type="text" className="box small"
                    placeholder="Short Description" onChange={(e) => setUpdShortDesc(e.target.value)}
                    value={updShortDesc} />

                  <br></br>
                  <button onClick={() => { updateDiagService(id) }} type="button"
                    className="btn solid round">Update DiagService</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DiagService;
